import React from "react";
import Spkapexcharts from "./spk-apexcharts";

const SalesStatisticsCard = ({ Saleoptions, Saleseries, Totals }) => (
  <div className="card custom-card">
    <div className="card-header d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">
        Sales Statistics
        <span className="ms-2 text-muted fs-13">
          {(() => {
            const today = new Date();
            const start = new Date(today);
            start.setDate(today.getDate() - 6);
            const format = d => `${d.getDate()} ${d.toLocaleString('default', { month: 'short' })}`;
            return `${format(start)} - ${format(today)}`;
          })()}
        </span>
      </h5>
     
    </div>
    <div className="card-body">
      <div className="d-flex gap-1 justify-content-between flex-fill pb-3">
        {typeof Totals === 'object' && Totals !== null &&
          Object.entries(Totals).map(([key, value]) => (
            <div className="py-3 px-3 rounded border border-dashed bg-light text-center" key={key}>
              <span>Total {key}</span>
              <p className="fw-medium fs-18 mb-0">{value}</p>
            </div>
          ))}
      </div>
      <div id="sales-statistics" style={{ width: '100%', height: 265 }}>
        <Spkapexcharts
          chartOptions={Saleoptions}
          chartSeries={Saleseries}
          type="line"
          width={"100%"}
          height={265}
        />
      </div>
    </div>
  </div>
);

export default SalesStatisticsCard;
